let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7eAVc")).then(() => parcelRequire('kWoux'));